import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@zola/zola-ui';
import cx from 'classnames';

import './ChecklistTaskProTip.less';

const ChecklistTaskProTip = ({ copy, url, urlText, fullWidth }) => (
  <div className={cx('checklist__proTip--container', { 'full-width': fullWidth })}>
    <span className="checklist__proTip--banner">
      <i className="zola-ui-icon zola-ui-icon-bulb icon__lightbulb" />
      Pro Tip
    </span>
    <p className="checklist__proTip--copy">{copy}</p>
    {url && (
      <div>
        <Link
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          caret
          caretPosition="postfix"
          className="checklist__proTip--link"
        >
          {urlText}
        </Link>
      </div>
    )}
  </div>
);

ChecklistTaskProTip.propTypes = {
  copy: PropTypes.string,
  fullWidth: PropTypes.bool,
};

ChecklistTaskProTip.defaultProps = {
  copy: '',
};

export default ChecklistTaskProTip;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskProTip/ChecklistTaskProTip.jsx